export default () => {
  const appContainers = document.querySelectorAll('script[data-src]');
  const scripts = [];
  const css = [];
  const addScript = (src) => {
    const tag = document.createElement('script');
    tag.src = src;
    tag.async = true;
    document.head.appendChild(tag);
  };
  const addCss = (href) => {
    const tag = document.createElement('link');
    tag.href = href;
    tag.rel = 'stylesheet';
    document.head.appendChild(tag);
  };
  [].forEach.call(appContainers, (container) => {
    const scriptSrc = container.dataset.src;
    const cssSrc = container.dataset.cssSrc;

    if (cssSrc && css.indexOf(cssSrc) < 0) {
      css.push(cssSrc);
      addCss(cssSrc);
    }
    if (scripts.indexOf(scriptSrc) < 0) {
      scripts.push(scriptSrc);
      addScript(scriptSrc);
    }

  });
};
